<template>
  <div class="content">
    <LinkPath current-path="consulta spid"/>
    <section id="myDiv">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="form-group">
              <form id="formBio" style="padding: 30px 15px">

                <div id="divAlert" class="alert alert-success" role="alert" style="display:none;"></div>

                <div v-if="stringDivMessage !== ''" v-bind:class="[ 'alert' , classDivMessage]" role="alert">
                  {{ stringDivMessage }}
                </div>

                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
                    <label for="idnOrSubjectSelect">Selecione o tipo de consulta</label>
                    <br/>
                    <select name="select" class="input-spacing" id="idnOrSubject" v-model="idnOrSubject"
                            @change="selecionandoIdnOuSubject()">
                      <option value="CPF">CPF</option>
                    </select>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
                    <label for="idnOrSubjectInput">Digite o número do {{ idnOrSubject }}</label>
                    <input type="text" class="input-spacing" id="idnOrSubjectInput" v-model="idnOrSubjectInput">
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
                    <label>&nbsp;</label>
                    <button type="button" v-on:click="efetuaConsultaPSBIO()" class="btn btn-primary form-control"
                            style="background-color: #211858">
                      Pesquisar
                    </button>
                  </div>
                </div>
              </form>
              <div style="padding: 0 30px 30px 30px" v-if="exibeResultadoConsulta">
                <div class="row" style="border-top: 1px solid #d2d6de; ">
                  <div style="padding-top: 20px">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                      <ImageFrame :url="'data:image/jpeg;base64,'+listaBiometricsArray.face.binaryData"/>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                      <HandFrame
                        :is-left="true"
                        :left-thumb="listaBiometricsArray.LeftThumb"
                        :left-index-finger="listaBiometricsArray.LeftIndexFinger"
                        :left-middle-finger="listaBiometricsArray.LeftMiddleFinger"
                        :left-ring-finger="listaBiometricsArray.LeftRingFinger"
                        :left-little-finger="listaBiometricsArray.LeftLittleFinger"
                      />
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                      <HandFrame
                        :is-right="true"
                        :right-thumb="listaBiometricsArray.RightThumb"
                        :right-index-finger="listaBiometricsArray.RightIndexFinger"
                        :right-middle-finger="listaBiometricsArray.RightMiddleFinger"
                        :right-ring-finger="listaBiometricsArray.RightRingFinger"
                        :right-little-finger="listaBiometricsArray.RightLittleFinger"
                      />
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                      <h2 class="hand-sub-tittle">CPF:</h2>
                      <p class="hand-sub-tittle-description">{{ cpfRetornado }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import interceptor from '../../interceptor'
import roles from '../../roles'
import LinkPath from '../components/LinkPath'
import ImageFrame from '../components/ImageFrame'
import HandFrame from '../components/HandFrame'
import DeleteModal from '../components/DeleteModal'
import FraudModal from '../components/FraudModal'

export default {
  name: 'PesqBio',
  components: {FraudModal, DeleteModal, HandFrame, ImageFrame, LinkPath},
  data: function () {
    return {
      listMotivos: [],
      idnOrSubject: 'CPF',
      idnOrSubjectInput: null,
      exibeResultadoConsulta: false,
      listaBiometrics: [],
      operation: null,
      inputSelecionado: null,
      stringDivMessage: '',
      classDivMessage: 'alert-success',
      classDivMessage2: 'alert-warning',
      listaBiometricsArray: {
        face: {
          binaryData: null
        },
        RightThumb: false,
        RightIndexFinger: false,
        RightMiddleFinger: false,
        RightRingFinger: false,
        RightLittleFinger: false,
        LeftThumb: false,
        LeftIndexFinger: false,
        LeftMiddleFinger: false,
        LeftRingFinger: false,
        LeftLittleFinger: false,
        cpfRetornado: '',
        idnRetornado: '',
        subjectRetornado: ''
      },
      motivo: '',
      cpf: '',
      fraud: false,
      idn: '',
      subject: '',
      description: '',
      safCode: '',
      key: 'MANAGE',
      obs: ''
    }
  },
  methods: {
    toggleClassByName(className, id) {
      $(id).toggle(className)
    },
    check: function (action) {
      return roles.checkrole(window.localStorage.getItem('role'), this.key, action)
    },
    selecionandoIdnOuSubject: function () {
      this.limparInputs()
    },
    efetuaConsultaPSBIO: function () {
      if (this.idnOrSubject === 'CPF') {
        this.idn = ''
        this.subject = $('#idnOrSubjectInput').val()
        this.cpf = $('#idnOrSubjectInput').val()
        this.consultaSPID('cpf')
      }
    },
    limparInputs: function () {
      this.idnOrSubjectInput = ''
      this.exibeResultadoConsulta = false
      this.stringDivMessage = ''
      this.classDivMessage = 'alert-success'
      this.classDivMessage2 = 'alert-warning'
      this.cpfRetornado = 'alert-success'
      this.idnRetornado = 'alert-success'
      this.subjectRetornado = 'alert-success'
      this.renewBiometricsListState()
    },
    renewBiometricsListState: function () {
      this.listaBiometricsArray = {
        face: {
          binaryData: null
        },
        RightThumb: false,
        RightIndexFinger: false,
        RightMiddleFinger: false,
        RightRingFinger: false,
        RightLittleFinger: false,
        LeftThumb: false,
        LeftIndexFinger: false,
        LeftMiddleFinger: false,
        LeftRingFinger: false,
        LeftLittleFinger: false
      }
    },
    showResponse: function(data) {
      this.exibeResultadoConsulta = true
      this.listaBiometrics = data.biometrics
      this.cpfRetornado = data.document
      this.cpf = data.document
      if (this.listaBiometrics.length > 0) {
        this.listaBiometrics.map((x) => {
          if (x.index === 10) {
            this.listaBiometricsArray.face.binaryData = x.content
          }
          if (x.index === 5) {
            this.listaBiometricsArray.RightThumb = true
          }
          if (x.index === 6) {
            this.listaBiometricsArray.RightIndexFinger = true
          }
          if (x.index === 7) {
            this.listaBiometricsArray.RightMiddleFinger = true
          }
          if (x.index === 8) {
            this.listaBiometricsArray.RightRingFinger = true
          }
          if (x.index === 9) {
            this.listaBiometricsArray.RightLittleFinger = true
          }
          if (x.index === 4) {
            this.listaBiometricsArray.LeftThumb = true
          }
          if (x.index === 3) {
            this.listaBiometricsArray.LeftIndexFinger = true
          }
          if (x.index === 2) {
            this.listaBiometricsArray.LeftMiddleFinger = true
          }
          if (x.index === 1) {
            this.listaBiometricsArray.LeftRingFinger = true
          }
          if (x.index === 0) {
            this.listaBiometricsArray.LeftLittleFinger = true
          }
        })
      }
    },
    consultaSPID: function (mode) {
      this.clear()
      let self = this
      if (mode === 'cpf') {
        this.operation = 'SEARCHBYCPF'
        this.inputSelecionado = this.cpf
      }
      if (this.inputSelecionado !== undefined && this.inputSelecionado !== '') {
        this.stringDivMessage = ''
        this.classDivMessage = ' alert-success'
        this.classDivMessage2 = ' alert-warning'
        interceptor.request('post', `api/v1/spid/getOperator/${this.inputSelecionado}`)
          .then(response => {
            self.renewBiometricsListState()
            if (response.status === 204 || !response.data) {
              this.stringDivMessage = `Não foi encontrado cadastro para o ${this.idnOrSubject} informado`
              this.classDivMessage = 'alert-danger'
              this.exibeResultadoConsulta = false
            } else if (response.data && response.data.biometrics && response.data.biometrics.length > 0) {
              self.showResponse(response.data)
            } else {
              this.stringDivMessage = `Não foram encontradas Biometrias para o ${this.idnOrSubject} informado`
              this.classDivMessage = 'alert-danger'
              this.exibeResultadoConsulta = false
            }
          })
          .catch((error) => {
            self.renewBiometricsListState()
            let msg = error.response.status
            if (msg === 404) {
              this.stringDivMessage = `Não foram encontradas Biometrias para o ${this.idnOrSubject} informado`
              this.classDivMessage = 'alert-danger'
              this.exibeResultadoConsulta = false
            } else if (msg === 302) {
              if (error.response.data && error.response.data.biometrics && error.response.data.biometrics.length > 0) {
                self.showResponse(error.response.data)
              } else {
                this.stringDivMessage = `Não foram encontradas Biometrias para o ${this.idnOrSubject} informado`
                this.classDivMessage = 'alert-danger'
                this.exibeResultadoConsulta = false
              }
            } else {
              this.stringDivMessage = 'Erro ao tentar pesquisar as biometrias. Serviço indisponível'
              this.classDivMessage = 'alert-danger'
              this.exibeResultadoConsulta = false
            }
          })
      } else {
        this.stringDivMessage = `Por favor insira o ${this.idnOrSubject} que deseja pesquisar`
        this.classDivMessage = 'alert-warning'
        this.exibeResultadoConsulta = false
      }
    },
    clear: function () {
      $('#divAlert').empty().hide()
      $('#titulo').hide()
      $('#userBio').attr('class', 'divBlank')
      $('#userBioInfo').attr('class', '')
      $('#userBioInfo').empty()
      $('#userBioFace').empty()
      $('#userBioDig').empty()
      $('#userBioException').empty()
    },
    print: function () {
      var conteudo = $('#divPrint').html()
      var telaImpressao = window.open('about:blank')
      telaImpressao.document.write('<style> .print{display: none;} @page {size:landscape;} .divBlank {background-color: white; height: 500px;} .divUserBio {background-color: white; height: 500px; border: 2px solid #7030C5; padding: 10px; border-radius: 3px;} .divUserBioInfo {border-left: 2px solid #7030C5; float: left; margin-left: 34px; width: 50%; height: 100%;} .divUserBioInfoNotFace {border-left: 2px solid #7030C5;  float: left; margin-left: 30%; width: 50%; height: 100%; } .divUserBioInfo h4 {margin-left: 10px;} .divUserBioInfo p {margin-left: 10px;} .divUserBioInfoNotFace h4 {margin-left: 10px;} .divUserBioInfoNotFace p {margin-left: 10px;} .imgBio {border-radius: 25px; width: 30%;} </style>')
      telaImpressao.document.write(conteudo)
      telaImpressao.window.print()
      telaImpressao.window.close()
    }
  },
  mounted() {
    interceptor.request('get', 'api/v1/delete/listmotivos', {})
      .then(response => {
        this.listMotivos = response.data
      })
  }
}

$(function () {
  $(document).ready(function () {
    $('#motivodesc').on('keyup', function (e) {
      $(this).val($(this).val().replace(/\//g, ''))
      $(this).val($(this).val().replace(/\\/g, ''))
    })
  })
})
</script>
<style scoped>
@page {
  size: landscape;
}

.hand-sub-tittle {
  font: var(--font-style-normal) 600 18px/30px var(--font-family-poppins);
  font-size: 14px;
  letter-spacing: var(--character-spacing-0);
  text-align: left;
  color: #494F54;
}

.hand-sub-tittle-description {
  margin-bottom: 20px;
  overflow-wrap: break-word;
}

.divUserBioInfo h4 {
  margin-left: 10px;
}

.divUserBioInfo p {
  margin-left: 10px;
}

.divUserBioInfoNotFace h4 {
  margin-left: 10px;
}

.divUserBioInfoNotFace p {
  margin-left: 10px;
}
.input-spacing {
  border: lightslategrey solid 1px;
  border-radius: 2%;
}
</style>



// WEBPACK FOOTER //
// ConsultaSPID.vue?e3eb47c0